module.exports = __webpack_public_path__ + "a5f996a6672c697339d2e7d2ffa56c31.pdf";